module.exports = __webpack_public_path__ + "static/media/glance2.fc04ad48.svg";